import {Hub} from 'yougile-model'
import {getAllMirroredHubs} from './get-all-mirrored-hubs'

export const isMirroredHub = (hub?: Hub): boolean => {
  if (!hub) {
    return false
  }

  const hubs = getAllMirroredHubs(hub)
  if (!hubs) {
    return false
  }

  return hubs?.length > 1
}
